const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'local';
const ENVIRONMENT_URL = process.env.REACT_APP_API_BASEURL || '';
const BACKRS_APP_URL = process.env.REACT_APP_BACKRS_URL || '';
const LUBAV_API_URL = process.env.REACT_APP_LUBAV_API_BASEURL || '';
const GROW_URL = process.env.REACT_APP_GROW_URL || '';

export { ENVIRONMENT, ENVIRONMENT_URL, LUBAV_API_URL, GROW_URL, BACKRS_APP_URL };
